import type { Attributes } from "@opentelemetry/api"
import { isAxiosError } from "axios"

/** HTTP facts of a failed request, empty for anything that is not an Axios error. */
export function httpErrorAttributes(err: unknown): Attributes {
  if (!isAxiosError(err)) return {}
  const attrs: Attributes = {}
  const method = err.config?.method
  const url = err.config?.url
  if (method) attrs["http.request.method"] = method.toUpperCase()
  if (url) attrs["url.path"] = url.slice(0, 300)
  if (err.code) attrs["error.type"] = err.code
  const response = err.response
  if (!response) return attrs
  attrs["http.response.status_code"] = response.status
  const requestId = response.headers?.["x-request-id"] ?? response.headers?.["x-amzn-requestid"]
  if (typeof requestId === "string") attrs["http.response.header.x_request_id"] = requestId
  const body = response.data
  const serialized = typeof body === "string" ? body : safeStringify(body)
  if (serialized) attrs["http.response.body"] = serialized.slice(0, 1000)
  return attrs
}

function safeStringify(value: unknown): string {
  if (value === undefined || value === null) return ""
  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}
